
import { useState } from 'react';

interface BotBadgeProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const BotBadge = ({ size = 'sm', showLabel = false, className = '' }: BotBadgeProps) => {
  const [hovered, setHovered] = useState(false);

  const sizeConfig = {
    xs: { badge: 'w-4 h-4', icon: 'text-[10px]', label: 'text-[10px]', gap: 'gap-0.5' },
    sm: { badge: 'w-5 h-5', icon: 'text-xs', label: 'text-xs', gap: 'gap-1' },
    md: { badge: 'w-6 h-6', icon: 'text-sm', label: 'text-sm', gap: 'gap-1' },
    lg: { badge: 'w-8 h-8', icon: 'text-base', label: 'text-sm', gap: 'gap-1.5' },
  };

  const config = sizeConfig[size];

  return (
    <div
      className={`relative inline-flex items-center ${config.gap} ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={`${config.badge} rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center shadow-sm cursor-default transition-transform hover:scale-110`}
      >
        <i className={`ri-robot-2-fill text-white ${config.icon}`}></i>
      </div>

      {showLabel && (
        <span className={`font-semibold bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent ${config.label} whitespace-nowrap`}>
          Bot
        </span>
      )}

      {hovered && !showLabel && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 pointer-events-none">
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 text-xs whitespace-nowrap shadow-lg">
            <div className="flex items-center gap-1.5">
              <i className="ri-robot-2-fill text-teal-400"></i>
              <span className="font-semibold">Bot Account</span>
            </div>
            <p className="text-gray-300 text-[11px] mt-0.5">Automated community member</p>
          </div>
          <div className="w-2 h-2 bg-gray-900 rotate-45 mx-auto -mt-1"></div>
        </div>
      )}
    </div>
  );
};

export default BotBadge;
